import { createTheme } from "@mantine/core";
import {
	COLOR_SCHEMES,
	COLOR_THEMES,
	type ColorScheme,
	type ColorTheme,
	canvasBgOf,
	PLAY_COLOR_TUPLES,
	parseColorTheme,
	THEME_TOKENS,
	themeSemantics,
} from "@play/shared";

export {
	COLOR_SCHEMES,
	COLOR_THEMES,
	type ColorScheme,
	type ColorTheme,
	canvasBgOf,
	parseColorTheme,
};

const THEME_STORAGE_KEY = "play-card.color-theme";

export function readStoredCardTheme(): ColorTheme {
	if (typeof localStorage === "undefined") {
		return "brand";
	}
	return parseColorTheme(localStorage.getItem(THEME_STORAGE_KEY));
}

export function persistCardTheme(theme: ColorTheme): void {
	if (typeof localStorage === "undefined") {
		return;
	}
	localStorage.setItem(THEME_STORAGE_KEY, theme);
}

export function themeFor(theme: ColorTheme, scheme: ColorScheme = "light") {
	const tokens = THEME_TOKENS[theme];
	return createTheme({
		fontFamily: '"DM Sans", system-ui, sans-serif',
		primaryColor: tokens.primary,
		defaultRadius: "lg",
		colors: {
			playRed: [...PLAY_COLOR_TUPLES.playRed],
			playMist: [...PLAY_COLOR_TUPLES.playMist],
			playBlue: [...PLAY_COLOR_TUPLES.playBlue],
			playGreen: [...PLAY_COLOR_TUPLES.playGreen],
			playBrown: [...PLAY_COLOR_TUPLES.playBrown],
			playSun: [...PLAY_COLOR_TUPLES.playSun],
		},
		other: {
			canvasBg: tokens.canvasBg[scheme],
			...themeSemantics(scheme),
			brand: "#E31C23",
		},
	});
}
